module.exports = __webpack_public_path__ + "img/Small-Bevel-Attachment-16.a29f12d7.png";